import * as PropTypes from "prop-types"
import isEmpty from "lodash/isEmpty"
import styled from "styled-components"
import Icon from "../../../icons/icon"
import { Checkbox } from "../../../icons/checkbox"
import { CheckboxSelected } from "../../../icons/checkboxSelected"

const Field = styled.input`
  display: none;
`

const StyledCheckbox = styled(Icon)`
  margin-left: -23px;
  margin-right: 5px;
  vertical-align: middle;
`

const StyledLabel = styled.label`
  display: block;
  font-size: 12px;
  line-height: 18px;
  padding-left: 23px;
`

export default function CheckBoxField(props) {
  const { label, name, errors, formName, value, handleChange, ...rest } = props

  const errorsValue = errors && errors[name]

  const onChange = e => {
    const { target } = e
    const newVal = target.type === "checkbox" ? target.checked : target.value
    if (handleChange) handleChange(name, newVal)
  }

  return (
    <div className="p-0 mb-3">
      <StyledLabel>
        {!value ? (
          <StyledCheckbox size="sm" color={errorsValue ? "crimson" : "silver"} Icon={Checkbox} focusable />
        ) : (
          <StyledCheckbox size="sm" color="deepPink" Icon={CheckboxSelected} focusable />
        )}
        <Field
          type="checkbox"
          value={value || false}
          className={!isEmpty(errorsValue) ? "is-invalid" : ""}
          name={name}
          id={`${formName}_${name}`}
          onChange={onChange}
          {...rest}
        />
        {label}
      </StyledLabel>
    </div>
  )
}

CheckBoxField.defaultProps = { color: "white", value: false }

CheckBoxField.propTypes = {
  color: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  formName: PropTypes.string.isRequired,
  value: PropTypes.bool,
  handleChange: PropTypes.func.isRequired
}
